// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__CRFrr","requiredAsterisk":"Info_requiredAsterisk__q5o4h"};